import { render } from "./AddTag.vue?vue&type=template&id=144e4bc0&scoped=true"
import script from "./AddTag.vue?vue&type=script&lang=js"
export * from "./AddTag.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-144e4bc0"

export default script